module.exports = __webpack_public_path__ + "static/jianyu3-d013e89f8fd5735978b1fb5c966b3e34.jpg";